import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Protocol17025Chart_Interface,Empty_Protocol17025Chart_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Chart_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { Protocol17025ChartService } from 'src/app/Service/Protocol17025/Protocol17025Chart.service';


@Component({
  selector: 'app-Protocol17025Chart',
  templateUrl: './Protocol17025Chart.component.html',
  styleUrls: ['./Protocol17025Chart.component.scss']
})
export class Protocol17025ChartComponent implements OnInit {
  Procssing:boolean=false


  constructor(
    private Protocol17025Chart_Service:Protocol17025ChartService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Protocol17025Chart:Array<Protocol17025Chart_Interface>=[]
  Selected_Protocol17025Chart:Protocol17025Chart_Interface=Empty_Protocol17025Chart_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1172).subscribe(
      data=>{
        this.ReadData_Protocol17025Chart()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Protocol17025Chart(){
    this.Procssing=true
    this.Protocol17025Chart_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Protocol17025Chart=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  //#region Edit

  modalRef_Edit: any;
  title_edit:String=''
  code_edit:String=''

  OnGet_Edit_Action(template: TemplateRef<any>,item: Protocol17025Chart_Interface) {
    this.Selected_Protocol17025Chart = item
    this.code_edit=this.Selected_Protocol17025Chart.code
    this.title_edit=this.Selected_Protocol17025Chart.title
    this.Copy_Item_Protocol=Empty_Protocol17025Chart_Interface()
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit() {
    if (!this.Selected_Protocol17025Chart.title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {
      var temp: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
      temp.id = this.Selected_Protocol17025Chart.id
      temp.parent = this.Selected_Protocol17025Chart.parent
      temp.chart_type = this.Selected_Protocol17025Chart.chart_type
      temp.title = this.title_edit
      temp.code = this.code_edit

      this.Protocol17025Chart_Service.AddEdit(temp).subscribe(
        data => {
          if (data['id'] == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در این سطح موجود است")
          }
          else if (data['id'] == -1) {
            this.Alertify_Service.ErrorMessage("کد وارد شده در چارت موجود است")
          }
          else {
            this.Selected_Protocol17025Chart.title=this.title_edit
            this.Selected_Protocol17025Chart.code=this.code_edit
            this.Alertify_Service.SuccessMessage("اطلاعات ویرایش شد")
            this.modalRef_Edit.hide()
          }
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Add

  modalRef_Add: any;
  Add_Step_Title: string = ''
  Add_Step_Code: string = ''

  On_Add_Root(template: TemplateRef<any>) {
    var temp: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
    temp.chart_type=1
    this.OnGet_Add_Action(template,temp)
  }

  OnGet_Add_Action(template: TemplateRef<any>,item: Protocol17025Chart_Interface) {
    this.Selected_Protocol17025Chart = item
    this.Copy_Item_Protocol=Empty_Protocol17025Chart_Interface()
    this.Add_Step_Title=""
    this.Add_Step_Code=""
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(id: number) {

    if (!this.Add_Step_Title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {
      var temp: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
      temp.title = this.Add_Step_Title
      temp.code = this.Add_Step_Code
      temp.chart_type = this.Selected_Protocol17025Chart.chart_type

      if (id == 0) {
        temp.parent = this.Selected_Protocol17025Chart.id
      }
      else {
        temp.parent = this.Selected_Protocol17025Chart.parent
      }


      this.Protocol17025Chart_Service.AddEdit(temp).subscribe(
        data => {
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در این سطح تکراری است.")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("کد وارد شده تکراری است.")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Protocol17025Chart()
            this.modalRef_Add.hide()
          }
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Delete

  modalRef_Delete: any;

  OnGet_Remove_Action(template: TemplateRef<any>,item: Protocol17025Chart_Interface) {
    this.Selected_Protocol17025Chart = item
    this.Copy_Item_Protocol=Empty_Protocol17025Chart_Interface()
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(id: number) {

    this.Protocol17025Chart_Service.Delete(this.Selected_Protocol17025Chart.id,id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
        this.ReadData_Protocol17025Chart()
        this.modalRef_Delete.hide()
      },
      error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion

  //#region Order

  Copy_Item_Protocol: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface();
  Copy_Item_Protocol_Up:Number=-1

  OnGet_Up_Action(item: Protocol17025Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 1
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Protocol17025Chart_Service.UpOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Protocol17025Chart()
      }
    )
    */
  }

  OnGet_Down_Action(item: Protocol17025Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 0
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Protocol17025Chart_Service.DownOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Protocol17025Chart()
      }
    )
    */
  }

  OnGet_Child_Action(item: Protocol17025Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 2
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Protocol17025Chart_Service.DownOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Protocol17025Chart()
      }
    )
    */
  }

  OnGet_Cut_Action(item: Protocol17025Chart_Interface) {

    if (this.Copy_Item_Protocol.id == 0) {
      this.Alertify_Service.ErrorMessage("موردی برای انتقال انتخاب نشده است")
    }
    else if (this.Copy_Item_Protocol_Up == 2)
    {
      this.Protocol17025Chart_Service.ChildOrder(this.Copy_Item_Protocol.id,item.id).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("!امکان انتقال به دلیل عدم همسطحی ، نیست")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Protocol17025Chart()
            this.Copy_Item_Protocol=Empty_Protocol17025Chart_Interface()
          }

        }
      )
    }
    else {
      this.Protocol17025Chart_Service.CutOrder(this.Copy_Item_Protocol.id,item.id,this.Copy_Item_Protocol_Up==1).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("!امکان انتقال به دلیل عدم همسطحی ، نیست")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Protocol17025Chart()
            this.Copy_Item_Protocol=Empty_Protocol17025Chart_Interface()
          }

        }
      )
    }
  }



  //#endregion

  //#region File

  Swicher_File_Tree:Protocol17025Chart_Interface=Empty_Protocol17025Chart_Interface()
  OnGet_File_Action(item: Protocol17025Chart_Interface) {
    this.Swicher_File_Tree=item
  }


  OnBack_From_File() {
    this.Swicher_File_Tree=Empty_Protocol17025Chart_Interface()
  }


  //#endregion

}
